module.exports = __webpack_public_path__ + "static/1304164659.141ddb2c.jpg";